import request from "@/utils/server.js";
// 产品中心获取行业分类一级二级列表数据  0  一级  二级根据选择的一级ID查询
export function getCompanyIndustryWxListAPI(params) {
  return request({
    url: "/wx/company/industry/wxList?parentId=" + params.parentld,
    method: "get",
  });
}

// 提交企业分类
export function insertCompanyTypeAPI(data) {
  return request({
    url: "/wx/company/insert/company/type",
    method: "post",
    data,
  });
}

// AI企业类别分析接口
export function aiAnalyseCompanyIndustryAPI(params) {
  return request({
    url: "/ai/imgtext/analyse/company/industry",
    method: "get",
    params,
  });
}

// 提交企业类型信息
export function submitCompanyTypeAPI(data) {
  return request({
    url: "/wx/type",
    method: "post",
    data,
  });
}
